// src/Routes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts';
import LoadingSpinner from './components/common/LoadingSpinner';
import PostAuthRedirect from './components/auth/PostAuthRedirect';

// Layout
import MainLayout from './components/layout/MainLayout';

// Import all pages from index
import {
  HomePage,
  LoginPage,
  RegisterPage,
  OAuthCallbackPage,
  DashboardPage,
  ProfilePage,
  SettingsPage,
  WalletPage,
  PowerUpsPage,
  GlobalLeaderboardPage,
  TermsPage,
  PrivacyPage,
  PredictionsPage,
  PredictionFormPage,
  PredictionHistoryPage,
  AnalyticsPage,
  GroupAnalyticsPage,
  GroupsPage,
  CreateGroupPage,
  JoinGroupPage,
  GroupDetailsPage,
  GroupManagementPage,
  GroupPredictionsPage,
  RivalryPage,
  NotFoundPage
} from './pages';

// Protected Route Component
import ProtectedRoute from './components/auth/ProtectedRoute';

const AppRoutes = () => {
  const { isAuthenticated, loading: authLoading } = useAuth();

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={
        authLoading ? (
          <LoadingSpinner fullScreen />
        ) : isAuthenticated ? (
          <PostAuthRedirect />
        ) : (
          <LoginPage />
        )
      } />
      <Route path="/register" element={
        authLoading ? (
          <LoadingSpinner fullScreen />
        ) : isAuthenticated ? (
          <PostAuthRedirect />
        ) : (
          <RegisterPage />
        )
      } />
      <Route path="/auth/oauth/google/callback" element={<OAuthCallbackPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      
      {/* Protected routes with MainLayout */}
      <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        {/* Dashboard routes */}
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/powerups" element={<PowerUpsPage />} />
        <Route path="/worldcup/leaderboard" element={<GlobalLeaderboardPage />} />
        
        {/* Prediction routes */}
        <Route path="/predictions" element={<PredictionsPage />} />
        <Route path="/predictions/new" element={<PredictionFormPage />} />
        <Route path="/predictions/edit/:id" element={<PredictionFormPage />} />
        <Route path="/predictions/history" element={<PredictionHistoryPage />} />
        
        {/* Analytics routes */}
        <Route path="/analytics" element={<AnalyticsPage />} />
        
        {/* Group routes */}
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/groups/create" element={<CreateGroupPage />} />
        <Route path="/groups/join" element={<JoinGroupPage />} />
        <Route path="/groups/:groupId" element={<GroupDetailsPage />} />
        <Route path="/groups/:groupId/predictions" element={<GroupPredictionsPage />} />
        <Route path="/groups/:groupId/rivalries" element={<RivalryPage />} />
        <Route path="/groups/:groupId/analytics" element={<GroupAnalyticsPage />} />
        <Route path="/groups/:groupId/manage" element={<GroupManagementPage />} />
      </Route>
      
      {/* Home route with redirect */}
      <Route path="/" element={
        authLoading ? (
          <LoadingSpinner fullScreen />
        ) : isAuthenticated ? (
          <Navigate to="/dashboard" replace />
        ) : (
          <HomePage />
        )
      } />
      
      {/* 404 route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;